import { render, staticRenderFns } from "./InstallmentsModal.vue?vue&type=template&id=c48cba88&scoped=true"
import script from "./InstallmentsModal.vue?vue&type=script&lang=js"
export * from "./InstallmentsModal.vue?vue&type=script&lang=js"
import style0 from "./InstallmentsModal.vue?vue&type=style&index=0&id=c48cba88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48cba88",
  null
  
)

/* custom blocks */
import block0 from "./InstallmentsModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports